export default "__VITE_ASSET__B9TrHS$9__"